import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import Header from '../components/Header/header'
import SubscribeSection from '../components/Subscribe'
import FooterSection from '../components/Footer'
import firebase from '../api/firestore'

const db = firebase.firestore()

export default function ItineraryPage({ match }) {
  const { id } = match.params
  const [item, setItem] = useState(null)
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(false)
  const [voteMessage, setVoteMessage] = useState('')

  useEffect(() => {
    const fetchItinerary = async () => {
      try {
        const doc = await db.collection('itineraries').doc(id).get()
        if (!doc.exists || !doc.data().approved) {
          setNotFound(true)
        } else {
          setItem({ id: doc.id, ...doc.data() })
        }
      } catch (err) {
        setNotFound(true)
      }
      setLoading(false)
    }
    fetchItinerary()
  }, [id])

  const handleUpvote = async () => {
    const votedKey = `exploroff-voted-${id}`
    if (localStorage.getItem(votedKey)) {
      setVoteMessage('You already upvoted this itinerary.')
      return
    }
    try {
      await db.collection('itineraries').doc(id).update({
        voteCount: (item.voteCount || 0) + 1
      })
      localStorage.setItem(votedKey, 'true')
      setItem((prev) => ({ ...prev, voteCount: (prev.voteCount || 0) + 1 }))
      setVoteMessage('')
    } catch (err) {
      setVoteMessage('Could not upvote. Please try again.')
    }
  }

  if (loading) {
    return (
      <>
        <Header />
        <div className="itinerary-page-loading">Loading...</div>
        <FooterSection />
      </>
    )
  }

  if (notFound) {
    return (
      <>
        <Header />
        <div className="itinerary-page-loading">
          <p>Itinerary not found or not yet approved.</p>
          <Link to="/submit-itinerary" className="exploroff-feed-map-link">
            Back to Community Itineraries
          </Link>
        </div>
        <FooterSection />
      </>
    )
  }

  const mapSrc = `https://maps.google.com/maps?q=${encodeURIComponent(item.name)}&output=embed`
  const submittedDate = item.createdAt
    ? new Date(item.createdAt.toDate()).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    : ''

  return (
    <>
      <Helmet>
        <title>{item.name} | ExplorOFF</title>
        <meta
          name="description"
          content={
            item.description
              ? item.description.slice(0, 155)
              : `Explore ${item.name} with the ExplorOFF community.`
          }
        />
        <meta property="og:title" content={`${item.name} | ExplorOFF`} />
        <meta
          property="og:description"
          content={item.description || `Explore ${item.name} with the ExplorOFF community.`}
        />
        <meta property="og:type" content="article" />
      </Helmet>

      <Header />

      <div className="main">
        <section className="about-us pt-trip gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center mb-5">
                  <h1>{item.name}</h1>

                  {item.description ? (
                    <p className="itinerary-page-description">{item.description}</p>
                  ) : null}

                  <div className="itinerary-page-meta">
                    {submittedDate ? (
                      <span className="itinerary-page-date">Submitted {submittedDate}</span>
                    ) : null}
                    <span className="itinerary-page-separator"> · </span>
                    <button
                      type="button"
                      className="exploroff-feed-vote-button itinerary-vote-btn"
                      onClick={handleUpvote}
                    >
                      👍 {item.voteCount || 0}
                    </button>
                    {voteMessage ? (
                      <span className="itinerary-page-votemsg">{voteMessage}</span>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id={`map-${id}`} className="about-us gray-light-bg">
          <iframe
            src={mapSrc}
            width="100%"
            height="450"
            title={item.name}
            frameBorder="0"
            allowFullScreen
            loading="lazy"
          />
        </section>

        <section className="about-us gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8 text-center">
                <a
                  href={item.googleMapsUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="itinerary-page-cta"
                >
                  View Full Route on Google Maps →
                </a>

                <p className="itinerary-page-back">
                  <Link to="/submit-itinerary">
                    ← Back to Community Itineraries
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <SubscribeSection />
      <FooterSection />
    </>
  )
}
